import axios from 'axios'
import * as querystring from 'querystring'

import config from '../config/urlConfig'
import formatAxiosError from '../util/formatAxiosError'
import axiosOptions from '../const/axios-options'

export default class {
    static getsHeader(keysContent, keysSetting) {
        let body = ({ contents: keysContent, settings: keysSetting })
        return axios
            .post(`${config.app.api}/api/header/gets-by-keys`, body, axiosOptions)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let formatedError = formatAxiosError(error)
                throw formatedError
            })
    }
}
